<template>
  <div class="activityClientList">
    <reportPageTemp
      ref="reportPageTemp"
      :reportParams="reportParams"
      :filter="filter"
    >
      <div class="flex-wrap">
        <div class="flex-al mb10 mr10">
          <span class="fs14 color-666">{{
            $t("views.Analysisreport.channelPerfReport.51h4zb879d40")
          }}</span>
          <div class="select-box" style="width: 260px">
            <el-date-picker
              v-model="filter.rang_time"
              type="daterange"
              @change="search"
              :range-separator="
                $t('views.Analysisreport.channelPerfReport.51h4zb87asw0')
              "
              value-format="yyyy-MM-dd"
              :start-placeholder="
                $t('views.Analysisreport.channelPerfReport.51h4zb87b7w0')
              "
              :end-placeholder="
                $t('views.Analysisreport.channelPerfReport.51h4zb87bk00')
              "
              :picker-options="pickerOptions"
              style="width: 260px"
            ></el-date-picker>
          </div>
        </div>
        <div class="flex-al mb10 mr10">
          <!-- <span class="mr10 fs14 color-666">{{
            $t("views.Analysisreport.admTrackReport.51yzwntly2o0")
          }}</span> -->
          <div class="select-box" style="width: 170px">
            <el-select
              v-model="filter.coursetype_id"
              clearable
              filterable
              :placeholder="
                $t('views.Analysisreport.admTrackReport.51yzwntm4j40')
              "
              @change="filterCourseCat"
            >
              <el-option
                v-for="(item, index) in filterList.coursetypeList"
                :key="index"
                :label="`${item.coursetype_cnname}(${item.coursetype_branch})`"
                :value="item.coursetype_id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="flex-al mb10 mr10">
          <div class="select-box" style="width: 170px">
            <el-select
              v-model="filter.coursecat_id"
              clearable
              filterable
              :placeholder="$t('Customersmanage.dac')"
              @change="search"
            >
              <el-option
                v-for="(item, index) in filterList.courseCatList"
                :key="index"
                :label="`${item.coursecat_cnname}(${item.coursecat_branch})`"
                :value="item.coursecat_id"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="flex-al mb10 mr10">
          <el-select
            filterable
            clearable
            style="width: 180px"
            @change="search"
            v-model="filter.client_tracestatus"
            :placeholder="$t('Analysisreport.bf')"
          >
            <!-- 跟踪状态：0待跟踪1持续跟踪2已邀约3已试听4已转正-1已无意向-2无效名单', -->
            <!-- <el-option :label="$t('Common.options')" value></el-option> -->
            <el-option :label="$t('views.Analysisreport.channelCrmDetailReport.51h4yx8frsw0')" value="0"></el-option>
            <el-option :label="$t('views.Analysisreport.channelCrmDetailReport.51h4yx8fs700')" value="1"></el-option>
            <el-option :label="$t('views.Analysisreport.channelCrmDetailReport.51h4yx8fss80')" value="2"></el-option>
            <el-option :label="$t('views.Analysisreport.channelCrmDetailReport.51h4yx8ft6c0')" value="3"></el-option>
            <el-option :label="$t('views.Analysisreport.channelCrmDetailReport.51h4yx8fthw0')" value="4"></el-option>
            <el-option :label="$t('views.Analysisreport.channelCrmDetailReport.51h4yx8fttw0')" value="-1"></el-option>
            <el-option :label="$t('views.Analysisreport.channelCrmDetailReport.51h4yx8fu5s0')" value="-2"></el-option>
          </el-select>
        </div>
        <div class="flex-al mb10 mr10">
          <div class="ipt-box" style="width: 280px">
            <el-input
              v-model="filter.keyword"
              clearable
            :placeholder="$t('Analysisreport.db')"
              @clear="search"
              @keyup.enter.native="search"
            ></el-input>
          </div>
          <el-button
            type="primary"
            size="mini"
            class="search-btn fs14"
            @click="search"
            >{{
              $t("views.Analysisreport.channelPerfReport.51h4zb87em80")
            }}</el-button
          >
        </div>
      </div>
    </reportPageTemp>
  </div>
</template>
<script>
import reportPageTemp from "@/components/report/tableTemplate";
import storeanalysisreport from "../analysisreport.js";
export default {
  name: "analysisreport-activityClientList",
  data() {
    return {
      reportParams: {
        wayString: "activityClientList", //传递到子组件的方法名称
        Title: "活动名单明细报表",
      },

      //筛选
      filter: {
        rang_time: "", //选择时间--必须定义为这个参数
        starttime: "",
        endtime: "",
        client_tracestatus: "",
        keyword: "",
        coursetype_id: "", //班组
        coursecat_id: "",

        // frommedia_name: "", //渠道类型
        // channel_id: "", //渠道明细
      },
      // 筛选的下拉列表
      filterList: {
        sourceList: [], //选择渠道类型-下拉数据
        channelList: [], //选择渠道明细-下拉数据
        coursetypeList: [], //班组-下拉数据
        courseCatList: [],
      },
      // 时间限制
      pickerOptions: {
        // disabledDate(time) {
        //   return time.getTime() > Date.now();
        // }
      },
    };
  },
  components: {
    reportPageTemp,
  },
  created() {
    this.filter.rang_time = [
      this.$Common.getAppointedDate(2, 0).startDate,
      this.$Common.getAppointedDate(2, 0).endDate,
    ];
    (this.filter.starttime = this.$Common.getAppointedDate(2, 0).startDate),
      (this.filter.endtime = this.$Common.getAppointedDate(2, 0).endDate);
    this.courseTypeRecruitApi();
    this.getTypeCourseCatApi();
  },
  mounted() {},
  methods: {
    //下拉列表->获取班组列表--zjb
    courseTypeRecruitApi() {
      this.$http
        .courseTypeRecruitApi({
          coursetype_isrecruit: 1,
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.filterList.coursetypeList = res.data.data.list;
          } else {
            this.filterList.coursetypeList = [];
          }
        });
    },
    filterCourseCat() {
      this.filter.coursecat_id = "";
      this.getTypeCourseCatApi();
      this.search();
    },
    getTypeCourseCatApi() {
      this.$http
        .getTypeCourseCatApi({
          coursetype_id: this.filter.coursetype_id,
        })
        .then((res) => {
          const { code, data: _jb } = res.data;

          const data = _jb;
          if (code === 200) {
            this.filterList.courseCatList = data.list;
          } else {
            this.filterList.courseCatList = [];
          }
        });
    },
    //检索
    search() {
      this.filter.starttime = this.filter.rang_time
        ? this.filter.rang_time[0]
        : "";
      this.filter.endtime = this.filter.rang_time
        ? this.filter.rang_time[1]
        : "";
      this.$refs.reportPageTemp.search();
    },
  },
};
</script>
<style lang="less">
@import url("../../../assets/less/manage.less");
@import url("../analysisreport.less");
.activityClientList {
  // height: 100vh;
  font-size: 20px;
}
</style>
